import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  HeaderComponent,
  FooterComponent,
  SideNavComponent,
} from '../../../shared';

@Component({
  selector: 'app-main',
  imports: [HeaderComponent, FooterComponent, SideNavComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent {}
